var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPackages(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.3333C9.31833 18.3333 8.66667 18.0583 7.36417 17.5083C4.12167 16.1383 2.5 15.4525 2.5 14.3V5.83333M10 18.3333C10.6817 18.3333 11.3333 18.0583 12.6358 17.5083C15.8783 16.1383 17.5 15.4525 17.5 14.3V5.83333M10 18.3333V9.4625M5 10L6.66667 10.8333M14.1667 3.33333L5.83333 7.5M6.93833 8.07583L4.50417 6.89833C3.16833 6.25166 2.5 5.92833 2.5 5.41666C2.5 4.905 3.16833 4.58166 4.50417 3.935L6.9375 2.7575C8.44167 2.03 9.19167 1.66666 10 1.66666C10.8083 1.66666 11.5592 2.03 13.0617 2.7575L15.4958 3.935C16.8317 4.58166 17.5 4.905 17.5 5.41666C17.5 5.92833 16.8317 6.25166 15.4958 6.89833L13.0625 8.07583C11.5583 8.80333 10.8083 9.16666 10 9.16666C9.19167 9.16666 8.44083 8.80333 6.93833 8.07583Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackages);
export default __webpack_public_path__ + "static/media/packages.87ff251400d7504425bb42f65e168bcd.svg";
export { ForwardRef as ReactComponent };